"use client";
import { Heading, RepeaterAttr, TextAttr } from "./attributes";
import { useBlock } from "./context";

/**
 * Frequently asked questions. Native <details>/<summary> (keyboard and screen
 * reader friendly, no JavaScript) and FAQPage structured data built from the
 * same attributes on the server (src/core/seo/page-seo.ts → faqItems). Open
 * while editing so every answer stays editable.
 */
export function FaqBlock() {
  const { editing } = useBlock();
  return <section className="cms-faq" style={{ maxWidth: "56rem", marginInline: "auto", padding: "2rem 1.5rem", lineHeight: 1.6 }}>
    <Heading name="heading" />
    <TextAttr name="intro" rich className="cms-faq-intro" />
    <RepeaterAttr name="items" className="cms-faq-items" addLabel={{ nl: "Vraag toevoegen", en: "Add question", de: "Frage hinzufügen" }}
      itemDefaults={() => ({ question: {}, answer: {} })}>
      {() => <details className="cms-faq-item" open={editing || undefined} style={{ borderBottom: "1px solid currentColor", padding: "0.75rem 0" }}>
        <summary style={{ cursor: "pointer", fontWeight: 600 }}><TextAttr name="question" placeholder="Vraag" /></summary>
        <TextAttr name="answer" rich className="cms-faq-answer" placeholder="Antwoord" />
      </details>}
    </RepeaterAttr>
  </section>;
}
